import React from 'react';
import { Page } from 'ecrion-components';
import NavBar from './NavBar';

const PageNotFound = ({ history }) => {
  return (
    <>
      <Page.NavBar variant="custom-children">
        <NavBar />
      </Page.NavBar>
      <Page.NotFound hideNavBar onClick={() => history.push('/')} />
    </>
  );
};

export default PageNotFound;
